import { fixDate, fixTime, getDateString } from "../helpers";
import { formatPay } from "../components/core/MustPay";
const ProcessesStudentAppointments = (studentappointments) => {
  const returnData = {
    scheduled: [],
    taken: [],
    canceled: [],
    roadtest: [],
  };
  studentappointments.map((data, index) => {
    if (data.Lesson_RT === "Less") {
      if (data.LessonStatus === "SCHEDULED") {
        const tempData = {
          InstName: data.InstName,
          Lesson_RTDate: fixDate(data.Lesson_RTDate),
          Lesson_Day: getDateString(data.Lesson_RTDate),
          Less_RTTime: fixTime(data.Less_RTTime),
          DateScheduled: fixDate(data.DateScheduled),
          MeetTime: fixTime(data.MeetTime),
          LessonType: data.LessonType,
          Loc: data.Loc,
          CurAmtOwed: formatPay(data.CurAmtOwed),
        };
        returnData.scheduled.push(tempData);
      }
      if (data.LessonStatus === "GIVEN") {
        const tempData = {
          InstName: data.InstName,
          Lesson_RTDate: fixDate(data.Lesson_RTDate),
          Lesson_Day: getDateString(data.Lesson_RTDate),
          Less_RTTime: fixTime(data.Less_RTTime),
          DateScheduled: fixDate(data.DateScheduled),
          LessonType: data.LessonType,
          Loc: data.Loc,
        };
        returnData.taken.push(tempData);
      }
      if (
        data.LessonStatus === "CXLLD BY INSTR" ||
        data.LessonStatus === "CXLLED>24 HRS" ||
        data.LessonStatus === "CXLLED<24 HRS" ||
        data.LessonStatus === "Cancelled" ||
        data.LessonStatus === "NO SHOW"
      ) {
        const tempData = {
          InstName: data.InstName,
          Lesson_RTDate: fixDate(data.Lesson_RTDate),
          Lesson_Day: getDateString(data.Lesson_RTDate),
          Less_RTTime: fixTime(data.Less_RTTime),
          DateScheduled: fixDate(data.DateScheduled),
          DateCancelled: fixDate(data.DateCancelled),
          LessonStatus: data.LessonStatus,
          LessonType: data.LessonType,
          Loc: data.Loc,
        };
        returnData.canceled.push(tempData);
      }
    }
    return null;
  });
  // return returnData;
  const test = Object.keys(returnData).map((i) => {
    returnData[i].sort(
      (a, b) => new Date(b.Lesson_RTDate) - new Date(a.Lesson_RTDate)
    );
  });
  return returnData;
};

export { ProcessesStudentAppointments };

const ProcessesRoadtestAppointments = (studentappointments) => {
  const returnData = {
    scheduled: [],
    taken: [],
    canceled: [],
    roadtest: [],
  };
  studentappointments.map((data, index) => {
    if (data.Lesson_RT === "RT") {
      if (data.LessonStatus === "SCHEDULED") {
        const tempData = {
          InstName: data.InstName,
          Lesson_RTDate: fixDate(data.Lesson_RTDate),
          Less_RTTime: fixTime(data.Less_RTTime),
          DateScheduled: fixDate(data.DateScheduled),
          MeetTime: fixTime(data.MeetTime),
          Loc: data.Loc,
          RoadTestStatus: data.RoadTestStatus,
          PassFail: data.PassFail,
          CarCost: formatPay(data.CarCost),
          ApptCost: formatPay(data.ApptCost),
        };
        returnData.scheduled.push(tempData);
      }
      if (data.LessonStatus === "GIVEN") {
        const tempData = {
          InstName: data.InstName,
          Lesson_RTDate: fixDate(data.Lesson_RTDate),
          Less_RTTime: fixTime(data.Less_RTTime),
          DateScheduled: fixDate(data.DateScheduled),
          Loc: data.Loc,
          RoadTestStatus: data.RoadTestStatus,
          PassFail: data.PassFail,
          CarCost: formatPay(data.CarCost),
          ApptCost: formatPay(data.ApptCost),
        };
        returnData.taken.push(tempData);
      }
      if (
        data.LessonStatus === "CXLLD BY INSTR" ||
        data.LessonStatus === "CXLLED>24 HRS" ||
        data.LessonStatus === "CXLLED<24 HRS" ||
        data.LessonStatus === "Cancelled" ||
        data.LessonStatus === "NO SHOW"
      ) {
        const tempData = {
          InstName: data.InstName,
          Lesson_RTDate: fixDate(data.Lesson_RTDate),
          Less_RTTime: fixTime(data.Less_RTTime),
          DateScheduled: fixDate(data.DateScheduled),
          Loc: data.Loc,
          RoadTestStatus: data.RoadTestStatus,
          PassFail: data.PassFail,
          CarCost: formatPay(data.CarCost),
          ApptCost: formatPay(data.ApptCost),
        };
        returnData.canceled.push(tempData);
      }
    }
    return null;
  });
  return returnData;
};

export { ProcessesRoadtestAppointments };

const ProcessCancelledAppointments = (appointmentCanceledData) => {
  const cancelled = [];
  appointmentCanceledData.map((data, index) => {
    if (
      data.LessonStatus === "CXLLED<24 HRS" ||
      data.LessonStatus === "NO SHOW"
    ) {
      const tempData = {
        Lesson_RTDate: fixDate(data.Lesson_RTDate),
        Lesson_Day: getDateString(data.Lesson_RTDate),
        Less_RTTime: fixTime(data.Less_RTTime),
        DateScheduled: fixDate(data.DateScheduled),
        LessonStatus: data.LessonStatus,
        Loc: data.Loc,
        DateCancelled: fixDate(data.DateCancelled),
        TimeCancelled: fixTime(data.TimeCancelled),
        CancelPenalty: formatPay(data.CancelPenalty),
      };
      cancelled.push(tempData);
    }
    return null;
  });
  return cancelled;
};

export { ProcessCancelledAppointments };

const ProcessFiveHourData = (data) => {
  return data.map((d) => {
    return {
      FiveHrClassDate: fixDate(d.FiveHrClassDate),
      CertificateNumber: d.CertificateNumber,
      FiveHrClassExpDate: fixDate(d.FiveHrClassExpDate),
      FiveHRCLCOST: formatPay(d.FiveHRCLCOST),
    };
  });
};

export { ProcessFiveHourData };

export const ProcessPaymentData = (data) => {
  return data.map((d) => ({
    ReceiptNum: d.ReceiptNum,
    PayDate: fixDate(d.PayDate),
    Payment: formatPay(d.Payment),
    ReasForPay: d.ReasForPay,
    TypeOfPay: d.TypeOfPay,
    OtherDisc: d.OtherDisc,
  }));
};

export const ProcessBalanceData = (data) => {
  if (data.length > 0) {
    return data.map((d) => ({
      TotalPayments: formatPay(d.TotalPayments),
      UsedAmount: formatPay(d.UsedAmount),
      NetUsed: formatPay(d.NetUsed),
      AmountOfCPenalty: formatPay(d.AmountOfCPenalty),
      Balance: formatPay(d.RemainingBalance),
    }));
  }
  return [
    {
      TotalPayments: "$ 0.00",
      UsedAmount: "$ 0.00",
      NetUsed: "$ 0.00",
      AmountOfCPenalty: "$ 0.00",
      Balance: "$ 0.00",
    },
  ];
};

const ProcessPackageData = (data) => {
  const cleanPackageData = [];
  data.forEach((d) => {
    const tempPackage = {
      PackageDetail: d.PackageDetail,
      LessonsPurchased: d.LessonsPurchased,
      LessonsTaken: d.LessonsTaken,
      LessonsScheduled: d.LessonsScheduled,
      LessonsLeft: d.LessonsLeft,
      LastLesson: fixDate(d.LastLesson),
      NextLesson: fixDate(d.NextLesson),
    };
    cleanPackageData.push(tempPackage);
  });
  return cleanPackageData;
};

export { ProcessPackageData };

const processBasicInfo = (data) => {
  if (data.length > 0) {
    return {
      student_info: [
        {
          a: data[0].StuFirst,
          b: data[0].StuMid,
          c: data[0].StuLast,
          d: data[0].SUFFIX,
          f: fixDate(data[0].DOB),
        },
      ],
      mailing: [
        {
          a: data[0].MAILADDRESS,
          f: data[0].MAILCrossX,
          g: data[0].MAILCrossY,
          b: data[0].MAILAPT,
          c: data[0].MAILCITY,
          d: data[0].MAILST,
          e: data[0].MAILZIP,
        },
      ],
      pickup: [
        {
          a: data[0].Address,
          b: data[0].CrossX,
          c: data[0].CrossY,
          d: data[0].City,
          e: data[0].ST,
          f: data[0].Zip,
        },
      ],
      contact: [
        {
          a: data[0].CellPh,
          b: data[0].DayPh,
          c: data[0].NitePh,
          d: data[0].Bpr,
          e: data[0].TextPh,
          f: data[0].Perm2tx,
          g: data[0].EmailAddress,
        },
      ],
      visitor: [{ a: data[0].VisStatus, b: data[0].VisStatusExp }],
    };
  }
};

export { processBasicInfo };
